import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import WaitlistForm from './WaitlistForm';

const CTASection = () => {
  return (
    <section className="relative overflow-hidden bg-[var(--lp-contrast-bg)] py-24 text-[var(--lp-contrast-text)] lg:py-28">
      <div className="lp-grain absolute inset-0" />

      <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <p className="font-mono text-[11px] font-semiboldtracking-[0.25em] text-[var(--lp-accent)]">
            Early access
          </p>
          <h2 className="mt-4 text-4xl font-semibold leading-[1.05] tracking-tight text-[var(--lp-contrast-text)] sm:text-5xl lg:text-6xl">
            Join the prepxai waitlist.
            <span className="block text-[var(--lp-contrast-text)]/45">We are opening access in batches.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-[var(--lp-contrast-text)]/55">
            Tell us where you are in your prep journey and we will invite the right early users first.
          </p>

          <div className="mx-auto mt-10 max-w-2xl text-left">
            <WaitlistForm tone="dark" />
          </div>

          <ul className="mt-10 flex flex-wrap justify-center gap-x-8 gap-y-3">
            {['No payment required', 'Invite-only beta', 'Launch updates by email'].map((item) => (
              <li key={item} className="flex items-center gap-2 text-sm text-[var(--lp-contrast-text)]/60">
                <Icon name="Check" size={14} className="text-[var(--lp-accent)]" />
                {item}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
